module.exports = __webpack_public_path__ + "img/ennetix-add-custom-app2.39aa5fee.png";